<template>
  <b-row>
    <b-col cols="12" class="mb-3">
      <label for="example-locales">催繳信件通知設定</label>
    </b-col>
    <b-col md="6">
      <label class="badge badge-pill badge-primary" for="timepicker1"
        >寄件時間</label
      >
      <b-form-timepicker
        id="timepicker1"
        v-model="sendMailTime"
        v-bind="labels[locale] || {}"
        :locale="locale"
        now-button
        show-seconds
        @context="onContext"
      ></b-form-timepicker>

      <div>
        <label class="badge badge-pill badge-primary" for="selected1"
          >寄件頻率</label
        >
        <b-form-select
          id="selected1"
          v-model="selected"
          :options="options"
        ></b-form-select>
      </div>

      <div>
        <button
          href="#"
          @click.prevent="updateSendMailTime()"
          class="btn btn-outline-info"
          type="button"
          style="font-size: 14px"
        >
          送出修改
        </button>
      </div>
    </b-col>
    <b-col> </b-col>
  </b-row>
</template>

<script>
import * as tools from '../tool'
export default {
  data () {
    return {
      inputData: {
        sendMailTime: null,
        count: null
      },
      sendMailTime: '',
      context: null,
      locale: 'zh-TW',
      locales: [{ value: 'zh-TW', text: '台灣(tw)' }],
      labels: {
        tw: {
          labelHours: '小時',
          labelMinutes: '分鐘',
          labelSeconds: '秒',
          labelAmpm: '上午下午',
          labelAm: '上午',
          labelPm: '下午',
          labelIncrement: '增量',
          labelDecrement: '减量',
          labelSelected: '選定時間',
          labelNoTimeSelected: '没有選定時間',
          labelCloseButton: '關閉'
        }
      },
      selected: null,
      options: [
        { value: 1, text: '1次/1天' },
        { value: 2, text: '1次/2天' },
        { value: 3, text: '1次/3天' }
      ]
    }
  },
  methods: {
    onContext (ctx) {
      this.context = ctx
      this.context.hour12 = false
      this.context.hour24 = true
    },
    getSendMailTime () {
      var vm = this
      this.$http
        .get('./WebApi/ociaRep/GetociaSendMailTime/')
        .then(function (response) {
          if (response.data != null) {
            vm.sendMailTime = response.data.sendMailTime
            vm.selected = response.data.count
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          return 2
        })
    },
    updateSendMailTime () {
      this.inputData.sendMailTime = this.sendMailTime
      this.inputData.count = this.selected
      var vm = this
      this.$http
        .put('./WebApi/ociaRep/SetociaSendMailTime/', this.inputData)
        .then(function (response) {
          if (response.data == 1) {
            tools.showAlert(vm, 'success', '更新成功')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          return 2
        })
    }
  },

  created () {
    console.log('======created View =====')
    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1
    this.getSendMailTime()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
